var _path, _path2, _radialGradient, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgPlexLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4103.18,
    height: 2339.532,
    viewBox: "-525.656 -459.391 4103.18 2339.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#494949",
    d: "M-525.656-459.391h4103.18v2339.532h-4103.18z"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plex-logo-light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3068.929 210.125h-290.001l-289.999 500 289.999 500h289.748l-289.748-499.75 290.001-500.25"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 1244.322,
    cy: 919.871,
    r: 0.925,
    gradientTransform: "matrix(610 0 0 -1000.5 -756323.625 921038.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9be03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc7c19"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M2168.94 210.125h290l320 500.25-320 500.25h-290l319.999-500.25-319.999-500.25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2068.886 1210.125h-577.073v-1000h577.073v173.737h-364.607v219.562h339.255v173.731h-339.255v257.864h364.607v175.106M774.215 1210.125v-1000h212.04v824.895h405.609v175.105H774.215M572.886 768.949c-67.268 57.007-162.91 85.501-286.938 85.501H194.98v355.675H-17.06V680.463l290 .359c177.562-2.069 186.842-110.818 186.842-148.497 0-34.979 0-146.755-157.842-148.5l-319 .003V210.125h319.424c121.293 0 213.515 26.107 276.677 78.321 63.152 52.213 94.733 130.071 94.733 233.581 0 107.624-33.633 189.928-100.888 246.922z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-17.06 320.125h212.2v429h-212.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlexLogo);
export default __webpack_public_path__ + "static/media/img-plex-logo.48ad9ea4d986b77d0227ca34a628f219.svg";
export { ForwardRef as ReactComponent };